import * as angular from "angular";
import * as React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import {
  DefectTypesAndClassifications,
  DefectTypeService,
} from "../../services/defects/defectType.service";
import {
  MachineActivity,
  SectionActivity,
  ShopActivity,
} from "../../models/activity/shopActivity";
import CheckListsServiceName, {
  CheckListsService,
} from "../../services/checkLists/checkLists.service";
import CheckListInstancesServiceName, {
  CheckListInstancesService,
} from "../../services/checkLists/checkListInstances.service";
import KPIChecksHubServiceName, {
  KPIChecksHubService,
  KPIChecksHub,
} from "../../services/checkLists/kpiChecks.hub";
import { apsEvents } from "../../shared/dto/aps.events";
import DefectCausesName, {
  openDefectCauses,
} from "../defectCauses/defectCauses.controller";
import AddDefectName, { openAddDefect } from "../defects/addDefect.controller";
import ViewDefectName, {
  openViewDefect,
} from "../defects/viewDefect.controller";
import AddDowntimeName, {
  openAddDowntime,
} from "../downtime/addDowntime.controller";
import AddJobChangeName, {
  openAddJobChange,
} from "../jobChange/addJobChange.controller";
import AddRequalificationName, {
  openAddRequalification,
} from "../requalification/addRequalification.controller";
import AddToolChangeName, {
  openAddToolChange,
} from "../toolChange/addToolChange.controller";
import ViewToolChangeName, {
  openViewToolChange,
} from "../toolChange/viewToolChange.controller";
import LineSheetServiceName, {
  LineSheetService,
} from "../../services/lineSheet/lineSheet.service";
import LoaderServiceName, {
  LoaderService,
} from "../../components/loader/loader.service";
import AuthDataServiceName, {
  AuthDataService,
} from "../../services/auth/authData.service";
import TempDataServiceName, {
  TempDataService,
} from "../../services/utility/tempDataService";
import DefectServiceName, {
  DefectService,
} from "../../services/defects/defect.service";
import ToolChangeServiceName, {
  ToolChangeService,
} from "../../services/toolChange/toolChange.service";
import NavigationServiceName, {
  NavigationService,
} from "../../services/navigation/navigation.service";
import LineSheetHubServiceName, {
  LineSheetHub,
  LineSheetHubService,
} from "./lineSheet.hub";
import UserProfileName, { UserProfile } from "../../models/userProfile";
import {
  LineSheetParams,
  LineSheetReactController,
} from "./lineSheet.controller";
import { States, Strings } from "../../shared/config/constant.module";
import JobRunActivity from "../../models/activity/jobRunActivity";
import GobActivity, {
  DowntimeActivity,
  GobDetailActivity,
  GobHourActivity,
  GobJobRunActivity,
  TopToolChange,
} from "../../models/activity/gobActivity";
import HourActivity from "../../models/activity/hourActivity";
import { CheckListReportParams } from "../checkLists/checkListReport.controller";
import DateUtilityService from "../../services/utility/dateutility.service";
import DefectActivity from "../../models/activity/defectActivity";
import ToolActivity from "../../models/activity/toolActivity";
import CavityHistoryName, {
  openCavityHistory,
} from "../toolHistory/cavityHistory.controller";
import MoldHistoryName, {
  openMoldHistory,
} from "../toolHistory/moldHistory.controller";
import QualificationHistoryName, {
  openQualificationHistory,
} from "../toolHistory/qualificationHistory";
import SectionHistoryName, {
  openSectionHistory,
} from "../toolHistory/sectionHistory.controller";
import FillOutCheckListName, {
  openFillOutCheckList,
} from "../checks/fillOutCheckList.controller";
import jobService, { JobService } from "../../services/jobs/job.service";

let requires = [
  KPIChecksHubServiceName,
  CheckListsServiceName,
  LineSheetServiceName,
  LoaderServiceName,
  AuthDataServiceName,
  DefectCausesName,
  AddDefectName,
  ViewDefectName,
  AddDowntimeName,
  AddJobChangeName,
  TempDataServiceName,
  DefectServiceName,
  ToolChangeServiceName,
  NavigationServiceName,
  LineSheetHubServiceName,
  UserProfileName,
  AddRequalificationName,
  AddToolChangeName,
  ViewToolChangeName,
  CavityHistoryName,
  MoldHistoryName,
  QualificationHistoryName,
  SectionHistoryName,
  CheckListInstancesServiceName,
  FillOutCheckListName,
  jobService,
];

interface KpiData {
  plantId: string;
  shopId: string;
  wellKnownCheck: apsEnums.WellKnownCheckType;
}

interface LineSheetDates {
  maxDate: moment.Moment;
  currentDate: moment.Moment;
  initialDate: Date;
  timeZone: string;
}

interface LineSheetState extends LineSheetDates {
  activityData: apsViewModels.ShopActivity;
  defectTypes: DefectTypesAndClassifications;
  tools: apsViewModels.ToolAndType[];
  equipment: apsViewModels.DefectEquipmentSelection[];
  activity: ShopActivity;
  activeMnr: apsViewModels.ActiveMnr[];
  userProfileData: apsViewModels.UserProfileData;
  machineVisibility: any;
  jobs: apsViewModels.JobItem[];
  jobProcesses: apsViewModels.JobProcess[];
}

class KpiComponent extends React.Component<
  KpiData,
  apsViewModels.CheckInstanceResultItem
> {
  private hub: KPIChecksHub;
  static checkListsService: CheckListsService;
  static kpiChecksHubService: KPIChecksHubService;
  private isUnmounted: boolean;

  private updateResult(update: apsEvents.WellKnownCheckUpdated) {
    if (
      this.isUnmounted ||
      (this.state &&
        this.state.scheduledOn.getDate() > update.eventDate.getDate())
    ) {
      return;
    }

    this.setState({
      id: update.id,
      checkId: update.checkId,
      status: update.status,
      result: update.result,
      checkName: update.checkName,
      wellKnownCheckId: update.wellKnownCheck,
      scheduledOn: update.eventDate,
    });
  }

  componentDidMount() {
    this.isUnmounted = false;
    KpiComponent.checkListsService
      .getLastValue(
        this.props.plantId,
        this.props.shopId,
        this.props.wellKnownCheck
      )
      .then((result) => {
        if (this.isUnmounted) {
          return;
        }

        if (<any>result === "") {
          return;
        }
        this.setState(result);
        this.hub = KpiComponent.kpiChecksHubService.createKPIChecksHub(
          (update) => this.updateResult(update),
          this.props.shopId,
          this.props.wellKnownCheck
        );
      });
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    if (this.hub) {
      this.hub
        .leaveGroup(this.props.shopId, this.props.wellKnownCheck)
        .then(() => {
          return this.hub.uninitialize();
        });
    }
  }

  render(): JSX.Element {
    if (this.state === null) {
      return React.createElement(
        "ul",
        { key: "kpi" },
        React.createElement("li", { key: "loading" }, "...")
      );
    }

    return React.createElement(
      "ul",
      { key: "kpi" },
      React.createElement("li", { key: "name" }, this.state.checkName),
      React.createElement(
        "li",
        { key: "result" },
        this.state.result ? this.state.result : "n/a"
      )
    );
  }
}

class LineSheetComponent extends React.Component<
  LineSheetReactController,
  LineSheetState
> {
  static userProfile: UserProfile;
  static lineSheetService: LineSheetService;
  static loaderService: LoaderService;
  static $q: angular.IQService;
  static defectTypeService: DefectTypeService;
  static defectService: DefectService;
  static toolChangeService: ToolChangeService;
  static $modal: mm.foundation.modal;
  static $state: angular.ui.IStateService;
  static tempDataService: TempDataService;
  static authDataService: AuthDataService;
  static checkListInstancesService: CheckListInstancesService;
  static lineSheetHub: LineSheetHubService;
  static $timeout: angular.ITimeoutService;
  private datePicker: any;
  private datePickerInitialized: boolean;
  private flags: {
    isAuthorized: boolean;
    isAdmin: boolean;
    isOperator: boolean;
    isHotEndOperator: boolean;
    isAuthorizedForQualifications: boolean;
    isAuthorizedForDefects: boolean;
    isAuthorizedForToolChanges: boolean;
    isAuthorizedForToolChangesComment: boolean;
    isAuthorizedForDowntime: boolean;
    isAuthorizedForHourlyDowntime: boolean;
    location: apsEnums.Location;
  };
  private hub: LineSheetHub;
  private refreshTimeout: angular.IPromise<any>;
  private initialLoadComplete: boolean;
  private isUnmounted: boolean;
  static navigationService: NavigationService;
  static jobService: JobService;

  private initializePermissions() {
    var auth = LineSheetComponent.authDataService;
    this.flags = {
      isAuthorized: auth.isAuthorizedForCurrentPlant(),
      isAdmin: auth.isPlantAdminForCurrentPlant(),
      isOperator: auth.isOperator(),
      isHotEndOperator: auth.isHotEndOperator(),
      isAuthorizedForQualifications: auth.isAuthorizedForQualifications(),
      isAuthorizedForDefects: auth.isAuthorizedForDefects(),
      isAuthorizedForToolChanges: auth.isAuthorizedForToolChanges(),
      isAuthorizedForToolChangesComment:
        auth.isAuthorizedForToolChangesComment(),
      isAuthorizedForDowntime: auth.isAuthorizedForDowntime(),
      isAuthorizedForHourlyDowntime: auth.isAuthorizedForHourlyDowntime(),
      location: auth.getSelectedRoleLocation().role.roleLocation,
    };
  }

  componentDidMount() {
    this.isUnmounted = false;
    this.datePickerInitialized = false;

    var navPromise = LineSheetComponent.navigationService
      .getNavigation()
      .then((navModel) => {
        this.initializePermissions();
        var plant = _.find(navModel.plants(), (p) =>
          _.some(p.shops, (s) => s.id === this.props.shopId)
        );
        var date = this.getLineSheetRequestDate(
          this.props.initialDate,
          plant.timeZoneId
        );
        return LineSheetComponent.$q
          .all([
            LineSheetComponent.lineSheetService.getLineSheetActivityData(
              this.props.shopId,
              date
            ),
            LineSheetComponent.defectTypeService.getDefectTypesAndClassifications(),
            LineSheetComponent.toolChangeService.getToolsAndTypes(),
            LineSheetComponent.defectService.getDefectEquipment(),
            LineSheetComponent.defectService.getActiveMnrs(
              this.props.shopId,
              date
            ),
            LineSheetComponent.userProfile.read(),
            LineSheetComponent.jobService.getJobs(),
            LineSheetComponent.jobService.getProcesses(),
          ])
          .then((response) => {
            if (this.isUnmounted) {
              return;
            }

            var activityData = response[0];
            var defectTypes = response[1];
            var tools = response[2];
            var equipments = response[3];
            var activeMnr = response[4];
            var userProfileData = response[5];
            var jobs = response[6];
            var processes = response[7];

            var activity = new ShopActivity(
              activityData,
              defectTypes,
              userProfileData,
              tools,
              jobs,
              processes,
              this.props.eightyHrTools,
              this.props.oneSixtyHrTools
            );
            var dates = this.initializeDates(
              this.props.initialDate,
              activity.timeZoneId
            );
            var machineVisibility = {};
            _.forEach(
              activity.machines,
              (machine) => (machineVisibility[machine.id] = true)
            );
            this.setState({
              activityData: activityData,
              defectTypes: defectTypes,
              tools: tools,
              equipment: equipments,
              activity: activity,
              maxDate: dates.maxDate,
              currentDate: dates.currentDate,
              initialDate: dates.initialDate,
              timeZone: dates.timeZone,
              activeMnr: activeMnr,
              userProfileData: userProfileData,
              machineVisibility: machineVisibility,
              jobs: jobs,
              jobProcesses: processes,
            });
            this.createActiveMnr();
            this.createCriticalDefectsIndicator();
            if (!date) {
              this.scheduleRefresh();
            }
            LineSheetComponent.$timeout(
              () => (this.initialLoadComplete = true),
              60000
            );
            this.hub =
              LineSheetComponent.lineSheetHub.createLineSheetHubForReact(
                () => this.state.activity,
                (updatedActivity) => this.updateActivity(updatedActivity),
                () => {
                  if (this.initialLoadComplete) {
                    this.getLineSheetActivityWithoutBlocking();
                  }
                },
                this.props.shopId
              );
          });
      });

    LineSheetComponent.loaderService.loadingPromise(navPromise);
  }

  private scheduleRefresh() {
    this.cancelRefresh();
    var now = new Date();
    var topOfTheHour =
      (59 - now.getMinutes()) * 60000 + (59 - now.getSeconds()) * 1000 + 5000;

    this.refreshTimeout = LineSheetComponent.$timeout(() => {
      if (this.isUnmounted) {
        return;
      }

      var activity = this.state.activity;
      activity.updateHours();
      var dates = this.initializeDates(null, this.state.timeZone);
      this.setState({
        activityData: this.state.activityData,
        defectTypes: this.state.defectTypes,
        tools: this.state.tools,
        equipment: this.state.equipment,
        activity: activity,
        maxDate: dates.maxDate,
        currentDate: dates.currentDate,
        initialDate: dates.initialDate,
        timeZone: this.state.timeZone,
        activeMnr: this.state.activeMnr,
        userProfileData: this.state.userProfileData,
        machineVisibility: this.state.machineVisibility,
        jobs: this.state.jobs,
        jobProcesses: this.state.jobProcesses,
      });
      this.scheduleRefresh();
    }, topOfTheHour);
  }

  private cancelRefresh() {
    if (this.refreshTimeout) {
      LineSheetComponent.$timeout.cancel(this.refreshTimeout);
      this.refreshTimeout = undefined;
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    this.cancelRefresh();

    if (this.hub) {
      this.hub.leaveGroup(this.props.shopId).then(() => {
        return this.hub.uninitialize();
      });
    }
  }

  private goToLive() {
    if (this.isLive()) {
      return;
    }

    this.getLineSheetActivity();
  }

  private nextDate() {
    if (this.isLive()) {
      return;
    }

    var date = moment(this.state.currentDate).add(1, "d");
    if (date.isAfter(this.state.maxDate)) {
      this.goToLive();
      return;
    }

    if (this.isDateLive(date)) {
      this.getLineSheetActivity();
    } else {
      this.getLineSheetActivity(date);
    }
  }

  private prevDate() {
    var date = moment(this.state.currentDate).subtract(1, "d");
    this.getLineSheetActivity(date);
  }

  private getLineSheetRequestDate(
    date: Date | moment.Moment,
    timeZoneId: string
  ) {
    if (date) {
      return moment(date).tz(timeZoneId).hours(23);
    }
    return null;
  }

  private saveAngularState(initialDate: Date) {
    var params: LineSheetParams = {
      plantId: this.props.plantId,
      shopId: this.props.shopId,
      userId: this.props.userId,
      initialDate: initialDate ? initialDate.toISOString() : undefined,
    };
    LineSheetComponent.$state.transitionTo(States.LINE_SHEET, params);
  }

  private getLineSheetActivityWithoutBlocking(
    date?: moment.Moment
  ): angular.IPromise<any> {
    var currentDate = date !== undefined ? moment(date) : undefined;
    date = this.getLineSheetRequestDate(date, this.state.timeZone);
    this.cancelRefresh();

    return LineSheetComponent.lineSheetService
      .getLineSheetActivityData(this.props.shopId, date)
      .then((response) => {
        var activityData = response;
        if (this.isUnmounted) {
          return;
        }

        var activity = new ShopActivity(
          activityData,
          this.state.defectTypes,
          this.state.userProfileData,
          this.state.tools,
          this.state.jobs,
          this.state.jobProcesses,
          this.props.eightyHrTools,
          this.props.oneSixtyHrTools
        );
        var initialDate = currentDate ? currentDate.toDate() : undefined;
        var dates = this.initializeDates(initialDate, activity.timeZoneId);
        this.setState({
          activityData: activityData,
          defectTypes: this.state.defectTypes,
          tools: this.state.tools,
          equipment: this.state.equipment,
          activity: activity,
          maxDate: dates.maxDate,
          currentDate: currentDate || dates.currentDate,
          initialDate: initialDate,
          timeZone: dates.timeZone,
          activeMnr: this.state.activeMnr,
          userProfileData: this.state.userProfileData,
          machineVisibility: this.state.machineVisibility,
        });
        this.saveAngularState(initialDate);
        if (!currentDate) {
          this.scheduleRefresh();
        }
      });
  }

  private getLineSheetActivity(date?: moment.Moment) {
    var promise = this.getLineSheetActivityWithoutBlocking(date);
    LineSheetComponent.loaderService.loadingPromise(promise);
  }

  private updateDate(newDate: Date) {
    var newMoment = moment(newDate).tz(this.state.timeZone);
    newMoment.add(0 - newMoment.utcOffset(), "m");
    if (newMoment.isSame(this.state.currentDate)) {
      return;
    }

    if (newMoment.isAfter(this.state.maxDate)) {
      this.goToLive();
      return;
    }

    if (this.isDateLive(newMoment)) {
      this.getLineSheetActivity();
    } else {
      this.getLineSheetActivity(newMoment);
    }
    this.updateActiveMnr();
  }

  componentDidUpdate(
    prevProps: LineSheetReactController,
    prevState: LineSheetState
  ) {
    if (this.datePickerInitialized) {
      return;
    }

    var element = <any>$(this.datePicker);

    element
      .fdatepicker({
        endDate: this.state.maxDate.toDate(),
      })
      .on("changeDate", (ev) => {
        this.updateDate(ev.date);
        element.fdatepicker("hide");
      });

    element.fdatepicker("update", this.state.currentDate.toDate());
    this.datePickerInitialized = true;
  }

  private isDateLive(newDate: moment.Moment): boolean {
    return newDate.isSame(this.state.maxDate);
  }

  private isLive(): boolean {
    return this.isDateLive(this.state.currentDate);
  }

  private getEquipmentName(equipmentId): string {
    return _.find(this.state.equipment, { id: equipmentId }).name;
  }

  private initializeDates(
    initialDate: Date,
    timeZone?: string
  ): LineSheetDates {
    timeZone = timeZone || Strings.DEFAULT_TIMEZONE;
    var maxDate = moment().tz(timeZone).startOf("day");
    var currentDate = moment(initialDate ? initialDate : maxDate);
    return {
      maxDate: maxDate,
      currentDate: currentDate,
      initialDate: initialDate,
      timeZone: timeZone,
    };
  }

  private currentJob(): JobRunActivity {
    if (this.state && this.state.activity.jobRuns.length > 0) {
      var job = _.last(this.state.activity.jobRuns);
      var hour = this.state.activity.hours[0];
      if (!job.endDate || job.endDate.getTime() > hour.endTime.getTime()) {
        return job;
      }
    }
    return undefined;
  }

  private viewSectionHistory(section: SectionActivity) {
    openSectionHistory(
      {
        section: section,
      },
      LineSheetComponent.$modal
    );
  }

  private viewCavityHistory(gob: GobActivity) {
    openCavityHistory(
      {
        gob: gob,
      },
      LineSheetComponent.$modal
    );
  }

  private viewMoldHistory(mold: apsViewModels.ToolActivity): any {
    openMoldHistory(
      {
        mold: mold,
      },
      LineSheetComponent.$modal
    );
  }

  private viewQualificationHistory(
    gob: GobActivity,
    location: apsEnums.Location
  ) {
    let result = openQualificationHistory(
      {
        activity: this.state.activity,
        gob: gob,
        location: location,
        timeZone: this.state.timeZone,
        isAuthorizedForRequalification:
          this.flags.isAuthorizedForQualifications &&
          this.flags.location === location &&
          (this.flags.isAdmin || !gob.hours[0].disabled),
      },
      LineSheetComponent.$modal
    );

    result.then((action) => {
      if (action === "add") {
        this.addRequalification(gob, this.state.activity.hours[0]);
      }
    });
  }

  private getSideRows() {
    var rows = [];
    var job = this.state.jobs.filter((x) => x.id == this.currentJob().jobId)[0];
    var process = this.state.jobProcesses.filter(
      (x) => x.id == job.processId
    )[0];
    let eightyHrTools = this.props.eightyHrTools.split(",");
    let oneSixtyHrTools = this.props.oneSixtyHrTools.split(",");
    eightyHrTools =
      process.name == "B&B"
        ? eightyHrTools.filter((x) => x !== "Plunger Clip")
        : eightyHrTools;

    _.forEach(this.state.activity.machines, (machine: MachineActivity) => {
      var machineVisible = !!this.state.machineVisibility[machine.id];
      rows.push(
        React.createElement(
          "tr",
          { key: machine.id },
          React.createElement(
            "td",
            {
              colSpan: "5",
              key: "name",
              onClick: () => {
                this.state.machineVisibility[machine.id] = !machineVisible;
                this.setState(this.state);
              },
            } as React.ClassAttributes<Element>,
            React.createElement("span", {}, machine.name + " "),
            React.createElement("i", {
              className: machineVisible ? "fa fa-minus" : "fa fa-plus",
            })
          )
        )
      );

      if (!machineVisible) {
        return;
      }

      _.forEach(machine.gobs, (gob: GobActivity) => {
        let toolSetOne = [];
        let toolSetTwo = [];
        var colorCode = [];
        var color;

        _.forEach(gob.toolChanges, (tool: ToolActivity) => {
          if (
            _.includes(eightyHrTools, tool.toolName) &&
            tool.timeRemoved === null
          ) {
            toolSetOne.push(tool);
          }
          if (
            _.includes(oneSixtyHrTools, tool.toolName) &&
            tool.timeRemoved === null
          ) {
            toolSetTwo.push(tool);
          }
        });

        _.forEach(toolSetOne, (toolChange: ToolActivity) => {
          var startTime = moment.utc(toolChange.timeChanged);
          var endTime = moment.utc();
          var totalHours = endTime.diff(startTime, "hour");
          var clr =
            totalHours > 92
              ? "Red"
              : totalHours >= 84 && totalHours <= 92
                ? "Orange"
                : "Green";
          colorCode.push(clr);
        });

        _.forEach(toolSetTwo, (toolChange: ToolActivity) => {
          var startTime = moment.utc(toolChange.timeChanged);
          var endTime = moment.utc();
          var totalHours = endTime.diff(startTime, "hour");
          var clr =
            totalHours > 160
              ? "Red"
              : totalHours >= 154 && totalHours <= 160
                ? "Orange"
                : "Green";
          colorCode.push(clr);
        });

        if (_.includes(colorCode, "Red")) {
          color = "Red";
        } else if (_.includes(colorCode, "Orange")) {
          color = "Orange";
        } else {
          color = "Green";
        }
        var columns = [];
        if (gob.gobNumber === 1) {
          var section = gob.section;
          columns.push(
            React.createElement(
              "td",
              {
                key: section.name,
                className: "major-row",
                rowSpan: section.gobs.length,
                onClick: () => this.viewSectionHistory(section),
              },
              React.createElement("span", { key: "name" }, section.name)
            )
          );
        }

        columns.push(
          React.createElement(
            "td",
            {
              key: gob.section.name + gob.name + "-mold",
              className: "mould-area",
              style: { backgroundColor: color },
              onClick: () => this.viewCavityHistory(gob),
            },
            React.createElement("span", { key: "name" }, gob.name)
          )
        );
        columns.push(
          React.createElement(
            "td",
            {
              key: gob.section.name + gob.name + "-gob",
              className: "gob-box",
            },
            _.map(gob.currentMolds, (mold) =>
              React.createElement(
                "span",
                {
                  key: mold.id,
                  style: { margin: "0 2px" },
                  onClick: () => this.viewMoldHistory(mold),
                  className: "mold-item",
                },
                mold.toolNumber
              )
            )
          )
        );
        columns.push(
          React.createElement(
            "td",
            {
              key: gob.section.name + gob.name + "-he",
              className: gob.qualificationHistory.heIsQualified
                ? "qualified is-hidden-small"
                : "not-qualified is-hidden-small",
              onClick: () =>
                this.viewQualificationHistory(gob, apsEnums.Location.HotEnd),
            },
            "H"
          )
        );
        columns.push(
          React.createElement(
            "td",
            {
              key: gob.section.name + gob.name + "-ce",
              className: gob.qualificationHistory.ceIsQualified
                ? "qualified is-hidden-small"
                : "not-qualified is-hidden-small",
              onClick: () =>
                this.viewQualificationHistory(gob, apsEnums.Location.ColdEnd),
            },
            "C"
          )
        );

        rows.push(
          React.createElement(
            "tr",
            {
              key: gob.section.name + gob.name,
            },
            columns
          )
        );
      });
    });
    return rows;
  }

  private goToChecks(hour: HourActivity) {
    var params: CheckListReportParams = {
      plantId: this.props.plantId,
      shopId: this.props.shopId,
      userId: this.props.userId,
      reportPlantId: undefined,
      locationId: undefined,
      startDate: hour.startTime.toISOString(),
      endDate: hour.endTime.toISOString(),
      checkListId: null,
      status: null,
      filter: apsEnums.CheckListReportFilter.AllCheckLists,
      autoRun: true,
    };

    LineSheetComponent.$state.go(States.CHECKLIST_REPORT, params);
  }

  private createCheckStatus(hour: HourActivity) {
    var divClassName = "check-bottomleft-pending";
    var iClassName = "fa fa-clock-o";
    if (hour.hasPassedChecks) {
      divClassName = "check-bottomleft-success";
      iClassName = "fa fa-check";
    } else if (hour.hasFailedChecks) {
      divClassName = "check-bottomleft-failed";
      iClassName = "fa fa-close";
    }
    return React.createElement(
      "div",
      {
        key: "checkStatus",
        className: divClassName,
        onClick: () => this.goToChecks(hour),
      },
      React.createElement("i", { key: "icon", className: iClassName })
    );
  }

  private toggleLock(hour: HourActivity) {
    if (!this.flags.isAdmin) {
      return;
    }

    var command = {
      shopId: this.props.shopId,
      hour: hour.startTime,
    };
    if (hour.isLocked) {
      LineSheetComponent.lineSheetService.unlockHour(command);
    } else {
      LineSheetComponent.lineSheetService.lockHour(command);
    }
  }

  private createLockUnlock(hour: HourActivity) {
    var className = "fa fa-unlock";
    if (hour.isLocked) {
      className = "fa fa-lock";
    }

    return React.createElement("i", {
      key: "lock",
      className: className,
      onClick: () => this.toggleLock(hour),
    });
  }

  private getHeader() {
    var columns = [];
    _.forEach(this.state.activity.hoursAndJobs, (item: any) => {
      if (item.isHour) {
        var hour = <HourActivity>item;
        columns.push(
          React.createElement(
            "th",
            {
              key: hour.id,
            },
            React.createElement(
              "div",
              { key: "hourDiv" },
              React.createElement(
                "span",
                { key: "hour", className: "hour" },
                hour.hour
              ),
              React.createElement(
                "span",
                { key: "period", className: "period" },
                hour.period
              ),
              this.createCheckStatus(hour),
              this.createLockUnlock(hour)
            )
          )
        );
      } else {
        var job = <JobRunActivity>item;
        columns.push(
          React.createElement(
            "th",
            {
              key: job.id,
            },
            React.createElement(
              "div",
              { key: "jobDiv", style: { fontSize: ".55em" } },
              React.createElement("nobr", { key: "jobName" }, job.shortName)
            )
          )
        );
      }
    });
    return React.createElement("tr", { key: "headerRow" }, columns);
  }

  private getBody() {
    var rows = [];
    _.forEach(this.state.activity.allActivity, (gob: GobActivity) => {
      if (
        !gob.isMachineLevel &&
        !this.state.machineVisibility[gob.section.machine.id]
      ) {
        return;
      }
      rows.push(
        React.createElement(
          "tr",
          {
            key: gob.name
              ? gob.section.name + gob.name
              : gob.section.machine.name,
          },
          this.getBodyColumns(gob)
        )
      );
    });
    return rows;
  }

  private getBodyColumns(gob: GobActivity) {
    var columns = [];
    _.forEach(gob.hoursAndJobs, (item: GobDetailActivity) => {
      if (item.isHour) {
        var hour = item as GobHourActivity;
        columns.push(
          React.createElement(
            "td",
            {
              key: hour.id,
              className: hour.hour.isLocked || hour.disabled ? "locked" : null,
            },
            this.getCellDetail(gob, hour)
          )
        );
      } else {
        var jobRun = item as GobJobRunActivity;
        columns.push(
          React.createElement(
            "td",
            {
              key: jobRun.id,
            },
            React.createElement(
              "div",
              { key: "molds" },
              _.map(jobRun.molds, (mold: apsViewModels.ToolActivity) =>
                React.createElement(
                  "span",
                  {
                    key: mold.id,
                    onClick: () => this.viewMoldHistory(mold),
                    className: "lineitem toolchange",
                  },
                  mold.toolNumber
                )
              )
            )
          )
        );
      }
    });
    return columns;
  }

  private createHoverOverWrapper(
    elements: React.ReactNode[],
    id: string,
    open: () => void,
    noCancelOrOpen?: boolean | undefined
  ): React.ReactNode {
    var closeHoverOver = () =>
      angular.element(".lineitem-hoverover:visible").hide();
    let hoverOverElements = elements;
    if (noCancelOrOpen !== true) {
      var footer = React.createElement(
        "div",
        {
          key: "footer",
          className: "row",
          style: { marginTop: "5px" },
        },
        React.createElement(
          "div",
          {
            key: "cancelDiv",
            className: "small-6 columns",
          },
          React.createElement(
            "button",
            {
              key: "cancelButton",
              type: "button",
              className: "tiny button secondary",
              style: { marginBottom: 0, padding: "10px" },
              onClick: closeHoverOver,
            },
            "Cancel"
          )
        ),
        React.createElement(
          "div",
          {
            key: "openDiv",
            className: "small-6 columns",
            style: { textAlign: "right" },
          },
          React.createElement(
            "button",
            {
              key: "openButton",
              type: "button",
              className: "tiny button",
              style: { marginBottom: 0, padding: "10px" },
              onClick: () => {
                if (open) {
                  open();
                }
                closeHoverOver();
              },
            },
            "Open"
          )
        )
      );
      hoverOverElements = elements.concat(footer);
    }
    return React.createElement(
      "div",
      { key: id + "-hover", className: "lineitem-hoverover" },
      hoverOverElements
    );
  }

  private createCreatedByRow(createdBy: string, time: Date): React.ReactNode {
    return React.createElement(
      "div",
      {
        key: "addedByDiv",
        className: "row",
      },
      React.createElement(
        "div",
        { key: "addedBy", className: "small-8 columns" },
        "Added by " + createdBy
      ),
      React.createElement(
        "div",
        {
          key: "addedOn",
          className: "small-4 columns",
          style: { textAlign: "right" },
        },
        DateUtilityService.formatTime(time, this.state.timeZone)
      )
    );
  }

  private createCommentRows(
    comments: {
      id: string;
      comment: string;
      createdOn: Date;
      createdByFullName: string;
    }[],
    elements: React.ReactNode[]
  ): void {
    if (!comments) {
      return;
    }

    _.forEach(comments, (comment) => {
      var commentElements = [];
      if (comment.createdByFullName && comment.createdOn) {
        commentElements.push(
          React.createElement(
            "div",
            {
              key: "createdByRow",
              className: "row name-time",
            },
            React.createElement(
              "div",
              { key: "createdBy", className: "small-8 columns" },
              comment.createdByFullName
            ),
            React.createElement(
              "div",
              {
                key: "createdOn",
                className: "small-4 columns",
                style: { textAlign: "right" },
              },
              DateUtilityService.formatTime(
                comment.createdOn,
                this.state.timeZone
              )
            )
          )
        );
      }
      commentElements.push(
        React.createElement(
          "div",
          { key: "commentRow", className: "row" },
          React.createElement(
            "div",
            {
              key: "comment",
              className: "small-12 columns",
              style: { whiteSpace: "normal" },
            },
            comment.comment
          )
        )
      );

      elements.push(
        React.createElement(
          "div",
          {
            key: comment.id,
            className: "hover-comment",
          },
          commentElements
        )
      );
    });
  }
  private updateActiveMnr() {
    LineSheetComponent.defectService
      .getActiveMnrs(this.props.shopId, null)
      .then((activeMnrs) => {
        this.setState({ activeMnr: activeMnrs });
        this.createActiveMnr();
      });
    LineSheetComponent.lineSheetService
      .getLineSheetActivityData(this.props.shopId, null)
      .then((response) => {
        this.setState({ activityData: response });
        this.createCriticalDefectsIndicator();
      });
  }

  private createActiveMnr() {
    var elements = [];
    let defects = this.state.activeMnr;

    let id = "active-mnr";
    var className = "lineitem active-mnr";
    if (defects.length > 0) {
      className = className + " workflow-indicator";
      elements.push(this.createMnrHoverOver(defects, id));
    } else {
      className = className + " is-hidden";
    }
    elements.push(
      React.createElement(
        "span",
        {
          key: id,
          className: className,
        },
        "Active MNR"
      )
    );

    return React.createElement(
      "div",
      {
        key: "active-mnr-container",
        className: "active-mnr-container linedetails is-hidden-small",
      },
      elements
    );
  }
  private createMnrHoverOver(defects: apsViewModels.ActiveMnr[], id: string) {
    var elements = [];
    var wrapperElements = [];
    var iClassName = "fa fa-bolt";
    elements.push(
      React.createElement(
        "div",
        {
          key: id + "Header",
          className: "row",
        },
        React.createElement(
          "div",
          {
            key: "title",
            className: "small-12 columns",
            style: {
              textAlign: "center",
              verticalAlign: "middle",
              fontWeight: "bold",
              //borderBottom: "1px solid #83aaba",
              margin: "5px 0",
              fontStyle: "italic",
            },
          },
          React.createElement("i", {
            key: "icon",
            className: iClassName,
            style: { color: "#1791CC", marginRight: "5px" },
          }),
          "Active MNR (Last 48 hrs)"
        )
      )
    );

    defects.forEach((defect, i) => {
      let rowClassName = "";
      if (i % 2 == 0) {
        rowClassName += " even";
      }

      let wrapper = React.createElement(
        "div",
        {
          key: id + "-" + i + "-row-" + defect.gobName,
          className: rowClassName,
          style: {
            padding: "5px",
            textAlign: "center",
            flex: "1 1 43%",
            background: "#f1f1effd",
          },
        },
        [
          React.createElement(
            "span",
            {
              key: "name",
              className: "bs-m-2",
            },
            defect.gobName
          ),
          React.createElement(
            "span",
            {
              key: "toolNum",
              className: "bs-m-2",
            },
            defect.toolNumber
          ),
          React.createElement(
            "span",
            {
              key: "timeFound",
              className: "bs-m-2",
            },
            defect.timeFound
          ),
        ]
      );
      wrapperElements = [...wrapperElements, wrapper];
    });

    elements = [
      ...elements,
      React.createElement(
        "div",
        {
          key: "body",
          className: "active-mnr-body",
          style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            overflow: "auto",
          },
        },
        wrapperElements
      ),
    ];

    return this.createHoverOverWrapper(elements, id, null, true);
  }
  private createCriticalDefectsIndicator() {
    if (!this.isLive()) return;
    var elements = [];
    var currentJob = this.currentJob();
    let defects = this.state.activityData.defects.filter(
      (d) => d.severity === 0 && d.createdOn >= currentJob.startDate
    );

    let id = "critical-defects";
    var className = "lineitem critical-defects-indicator";
    if (defects.length > 0) {
      className = className + " workflow-indicator";
      elements.push(this.createCriticalDefectHoverOver(defects, id));
    } else {
      className = className + " is-hidden";
    }
    elements.push(
      React.createElement(
        "span",
        {
          key: id,
          className: className,
        },
        "Critical Defects"
      )
    );

    return React.createElement(
      "div",
      {
        key: "critical-defects-indicator-container",
        className:
          "critical-defects-indicator-container linedetails is-hidden-small",
      },
      elements
    );
  }
  private createCriticalDefectHoverOver(
    defects: apsViewModels.DefectActivity[],
    id: string
  ) {
    var elements = [];
    var wrapperElements = [];
    var iClassName = "fa fa-exclamation";
    elements.push(
      React.createElement(
        "div",
        {
          key: id + "Header",
          className: "row",
        },
        React.createElement(
          "div",
          {
            key: "title",
            className: "small-12 columns",
            style: {
              display: "ruby",
              textAlign: "center",
              verticalAlign: "middle",
              fontWeight: "bold",
              margin: "5px 0",
              fontStyle: "italic",
            },
          },
          React.createElement("i", {
            key: "icon",
            className: iClassName,
            style: { color: "rgb(248, 78, 78)", marginRight: "5px" },
          }),
          "Critical Defects (Last 24 hrs)",
          React.createElement(
            "span",
            {
              key: "tile",
              style: {
                textAlign: "center",
                verticalAlign: "middle",
                fontWeight: "bold",
                background: "#696969",
                margin: "5px",
                padding: "2px",
                fontStyle: "italic",
                color: "white",
                width: "auto",
              },
            },
            "1000"
          )
        )
      )
    );

    defects.forEach((defect, i) => {
      let rowClassName = "";
      if (i % 2 == 0) {
        rowClassName += " even";
      }

      let sectionName = null;
      if (
        this.state &&
        this.state.activity &&
        this.state.activity.sections
      ) {
        const currentSection = this.state.activity.sections
          .filter(s => s.machine && s.machine.id === defect.isMachineId)
          .filter(s => s.sectionNumber === defect.section);
        if (currentSection.length > 0) {
          sectionName = currentSection[0].name;
        }
      }

      let wrapper = React.createElement(
        "div",
        {
          key: id + "-" + i + "-row-" + defect.gobName,
          className: rowClassName,
          style: {
            padding: "5px",
            textAlign: "center",
            flex: "1 1 46%",
            background: "#f1f1effd",
          },
        },
        [
          React.createElement(
            "span",
            {
              key: "name",
              className: "bs-m-2",
            },
            sectionName + "-" + defect.gobName),
          React.createElement(
            "span",
            {
              key: "rejectEnd",
              className: "bs-m-2",
            },
            defect.rejectEnd ? DateUtilityService.formatTime(defect.rejectEnd, this.state.timeZone) : ""
          ),
          React.createElement(
            "div",
            {
              key: "timeLeft",
              className: "bs-m-2",
              style: {
                fontWeight: "bold",
              },
            },
            "Time Left: " +
            (defect.rejectEnd
              ? this.calcTimeLeft(defect.rejectEnd)
              : "Reject End Not Set")
          ),
        ]
      );
      wrapperElements = [...wrapperElements, wrapper];
    });

    elements = [
      ...elements,
      React.createElement(
        "div",
        {
          key: "body",
          className: "critical-defects-body",
          style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            overflow: "auto",
          },
        },
        wrapperElements
      ),
    ];

    return this.createHoverOverWrapper(elements, id, null, true);
  }

  private calcTimeLeft(rejectEnd: Date) {
    // add 24 hours (in milliseconds)
    const dueTime = DateUtilityService.timeZoneToLocal(new Date(rejectEnd.getTime() + 24 * 60 * 60 * 1000), this.state.timeZone).toDate();
    const now = DateUtilityService.timeZoneToLocal(new Date(), this.state.timeZone).toDate();

    // calculate time left
    const timeLeftMs = dueTime.getTime() - now.getTime();

    if (timeLeftMs > 0) {
      const hours = Math.floor(timeLeftMs / (1000 * 60 * 60));
      return hours ? `${hours}h` : "-";
    }
  }

  private createDefectHoverOver(
    defect: DefectActivity,
    open: () => void
  ): React.ReactNode {
    var elements = [];
    elements.push(
      this.createCreatedByRow(defect.createdByFullName, defect.timeFound)
    );

    var headerText = defect.name;
    if (defect.defectTypeLegacyId) {
      headerText = defect.defectTypeLegacyId + " " + headerText;
    }
    var defectHeaderElements = [
      React.createElement(
        "div",
        { key: "name", className: "small-7 columns" },
        headerText
      ),
    ];
    if (defect.equipmentId) {
      defectHeaderElements.push(
        React.createElement(
          "div",
          {
            key: "equipName",
            className: "small-3 columns",
            style: { textAlign: "center" },
          },
          React.createElement(
            "span",
            {
              key: "equipNameSpan",
              className: "defectequipment",
              style: { padding: "3px" },
            },
            this.getEquipmentName(defect.equipmentId)
          )
        )
      );
    }
    if (defect.toolNumber) {
      defectHeaderElements.push(
        React.createElement(
          "div",
          {
            key: "toolNumber",
            className: "small-2 columns",
            style: { textAlign: "right" },
          },
          React.createElement(
            "span",
            {
              key: "toolNumberSpan",
              className: "toolchange",
              style: { padding: "3px" },
            },
            defect.toolNumber
          )
        )
      );
    }

    elements.push(
      React.createElement(
        "div",
        {
          key: "defectHeader",
          className: "row " + defect.severityClass,
          style: { marginTop: "5px", padding: "5px", color: "#FFFFFF" },
        },
        defectHeaderElements
      )
    );

    if (defect.isMoldRejectInUse) {
      var startTime = DateUtilityService.formatTimeOnly(
        defect.rejectStart,
        this.state.timeZone
      );
      var endTime = defect.rejectEnd
        ? DateUtilityService.formatTimeOnly(
          defect.rejectEnd,
          this.state.timeZone
        )
        : null;
      elements.push(
        React.createElement(
          "div",
          {
            key: "moldReject",
            className: "row",
            style: { marginTop: "5px", color: "#FF0000" },
          },
          "Rejected from " + startTime + (endTime ? " to " + endTime : "")
        )
      );
    }

    if (defect.isFrequencyCount()) {
      elements.push(
        React.createElement(
          "div",
          {
            key: "frequencyCount",
            className: "row",
            style: { marginTop: "5px" },
          },
          "Frequency: " + defect.frequencyCount + " / " + defect.frequencyTotal
        )
      );
    }
    if (defect.isFrequencyPercentage()) {
      elements.push(
        React.createElement(
          "div",
          {
            key: "frequencyPercent",
            className: "row",
            style: { marginTop: "5px" },
          },
          "Frequency: " + defect.frequencyPercent + "%"
        )
      );
    }
    if (defect.isFrequencyPSI()) {
      elements.push(
        React.createElement(
          "div",
          {
            key: "frequencyPSI",
            className: "row",
            style: { marginTop: "5px" },
          },
          "PSI: " +
          defect.frequencyCount +
          " failed / " +
          defect.frequencyTotal +
          " tested"
        )
      );
    }
    if (defect.isFrequencyThermal()) {
      elements.push(
        React.createElement(
          "div",
          {
            key: "frequencyThermal",
            className: "row",
            style: { marginTop: "5px" },
          },
          "Thermal Shock: " +
          defect.frequencyCount +
          " failed / " +
          defect.frequencyTotal +
          " tested"
        )
      );
    }

    this.createCommentRows(defect.comments, elements);

    return this.createHoverOverWrapper(elements, defect.id, open);
  }

  private createToolTable(
    header: string,
    tools: ToolActivity[]
  ): React.ReactNode {
    if (!tools || tools.length === 0) {
      return null;
    }
    var elements = [];
    var sortedTools = _.sortBy(tools, "toolName");
    _.forEach(sortedTools, (tool: ToolActivity) => {
      elements.push(
        React.createElement(
          "tr",
          {
            key: tool.id,
          },
          React.createElement("td", { key: "toolName" }, tool.toolName),
          React.createElement(
            "td",
            { key: "toolNumber" },
            tool.toolIsMold
              ? React.createElement(
                "span",
                {
                  key: "moldNumber",
                  className: "toolchange",
                  style: { padding: "3px", color: "#FFFFFF" },
                },
                tool.toolNumber
              )
              : tool.toolNumber
                ? tool.toolNumber.toString()
                : ""
          ),
          React.createElement("td", { key: "reason" }, tool.getReason()),
          React.createElement("td", { key: "defectName" }, tool.defectTypeName)
        )
      );
    });
    return React.createElement(
      "table",
      {
        key: header,
        className: "history-t",
        style: { marginTop: "5px" },
      },
      React.createElement(
        "thead",
        { key: "header" },
        React.createElement(
          "tr",
          { key: "topHeader" },
          React.createElement(
            "th",
            {
              key: "headerText",
              colSpan: "4",
            } as React.ClassAttributes<Element>,
            header
          )
        ),
        React.createElement(
          "tr",
          { key: "secondHeader" },
          React.createElement("th", { key: "tool" }, "Tool"),
          React.createElement("th", { key: "number" }, "No."),
          React.createElement("th", { key: "reason" }, "Reason"),
          React.createElement("th", { key: "defectTypeName" }, "Defect")
        )
      ),
      React.createElement("tbody", { key: "body" }, elements)
    );
  }

  private createToolChangeHoverOver(
    toolChange: TopToolChange,
    gob: GobActivity,
    open: () => void
  ): React.ReactNode {
    var elements = [];
    var firstToolChange = toolChange.tools[0];
    elements.push(
      this.createCreatedByRow(
        firstToolChange.createdByFullName,
        toolChange.timeChanged
      )
    );

    var toolNames = _.map(
      _.sortBy(toolChange.tools, "toolName"),
      "toolName"
    ).join(", ");
    elements.push(
      React.createElement(
        "div",
        {
          key: "toolNames",
          className: "row",
          style: { marginTop: "5px", whiteSpace: "normal" },
        },
        toolNames
      )
    );

    elements.push(
      React.createElement(
        "div",
        {
          key: "duration",
          className: "row",
          style: { marginTop: "5px" },
        },
        "Downtime: " + firstToolChange.duration + " minutes"
      )
    );

    var gobTools = _.filter(
      toolChange.tools,
      (t) => t.toolType === apsEnums.ToolType.Mold
    );
    var section = gob.section;
    if (gobTools.length > 0) {
      elements.push(
        this.createToolTable("Cavity " + section.name + gob.name, gobTools)
      );
    }

    var sectionTools = _.filter(
      toolChange.tools,
      (t) => t.toolType === apsEnums.ToolType.Variable
    );
    if (sectionTools.length > 0) {
      elements.push(
        this.createToolTable("Section " + section.name, sectionTools)
      );
    }

    var machineTools = _.filter(
      toolChange.tools,
      (t) => t.toolType === apsEnums.ToolType.Machine
    );
    if (machineTools.length > 0) {
      elements.push(this.createToolTable(section.machine.name, machineTools));
    }

    this.createCommentRows(toolChange.comments, elements);

    return this.createHoverOverWrapper(elements, toolChange.id, open);
  }

  private createDowntimeHoverOver(
    downtime: DowntimeActivity,
    gob: GobActivity,
    open: () => void
  ): React.ReactNode {
    var elements = [];
    elements.push(
      this.createCreatedByRow(
        downtime.createdByFullName,
        downtime.downtimeStart
      )
    );

    elements.push(
      React.createElement(
        "div",
        {
          key: "section",
          className: "row",
          style: { marginTop: "5px" },
        },
        "Section: " +
        (downtime.section ? gob.section.name : gob.section.machine.name)
      )
    );

    if (downtime.duration) {
      elements.push(
        React.createElement(
          "div",
          {
            key: "duration",
            className: "row",
            style: { marginTop: "5px" },
          },
          "Downtime: " + downtime.duration + " minutes"
        )
      );
    }

    elements.push(
      React.createElement(
        "div",
        {
          key: "reason",
          className: "row",
          style: { marginTop: "5px" },
        },
        "Reason: " +
        downtime.downtimeReasonDescription +
        " (" +
        downtime.downtimeReasonCode +
        ")"
      )
    );

    this.createCommentRows(downtime.comments, elements);

    return this.createHoverOverWrapper(elements, downtime.id, open);
  }

  private getCellDetail(gob: GobActivity, hour: GobHourActivity) {
    var elements = [];
    if (!hour.hour.jobRun) {
      return elements;
    }

    var activity = _.sortBy(
      hour.activity,
      (a: any) =>
        0 - (a.timeFound || a.timeChanged || a.downtimeStart).getTime()
    );

    _.forEach(activity, (activity: any) => {
      var className = "lineitem";
      var open = null;
      if (activity.isDefect) {
        var defect = <DefectActivity>activity;
        open = () =>
          this.viewDefect(
            gob,
            hour,
            defect,
            !this.flags.isAuthorizedForDefects
          );
        elements.push(this.createDefectHoverOver(defect, open));

        className = className + " " + defect.severityClass;
        if (defect.hasOpenMoldReject) {
          className = className + " workflow-indicator";
        }
        if (defect.isEquipmentFailure && !defect.maintenanceEnd) {
          className = className + " workflow-indicator-maint";
        }
        if (defect.rejectStart) {
          className = className + " mnr";
        }
        elements.push(
          React.createElement(
            "span",
            {
              key: defect.id,
              className: className,
              onClick: open,
            },
            defect.idAbbr()
          )
        );
      } else if (activity.isToolChange) {
        var toolChange = <TopToolChange>activity;
        open = () =>
          this.viewToolChange(
            gob,
            hour,
            toolChange,
            !this.flags.isAuthorizedForToolChanges
          );
        elements.push(this.createToolChangeHoverOver(toolChange, gob, open));

        var mold = _.find(toolChange.tools, (t) => t.toolIsMold);
        className = className + " toolchange";
        elements.push(
          React.createElement(
            "span",
            {
              key: toolChange.id,
              className: className,
              onClick: open,
            },
            React.createElement("i", {
              key: "icon",
              className: "fa fa-wrench",
            }),
            React.createElement(
              "span",
              { key: "toolNumber" },
              mold ? mold.toolNumber : ""
            )
          )
        );
      } else if (activity.isDowntime) {
        var downtime = <DowntimeActivity>activity;
        open = () =>
          this.viewDowntime(
            gob.section,
            hour,
            downtime,
            !this.flags.isAuthorizedForDowntime
          );
        elements.push(this.createDowntimeHoverOver(downtime, gob, open));

        className = className + " downtime";
        if (!(downtime.duration > 0)) {
          className = className + " workflow-indicator";
        }
        elements.push(
          React.createElement(
            "span",
            {
              key: downtime.id,
              className: className,
              onClick: open,
            },
            React.createElement("i", {
              key: "icon",
              className: "fa fa-clock-o",
            })
          )
        );
      }
    });

    var menu = this.createMenu(gob, hour);
    if (menu) {
      elements.push(menu);
      if (this.flags.isAdmin || (!hour.hour.isLocked && !hour.disabled)) {
        elements.push(
          React.createElement("i", {
            key: "openMenu",
            className: "fa fa-plus-square add-menu-trigger",
          })
        );
      }
    }

    return elements;
  }

  private createAddJobChangeMenuElement(
    elements: any[],
    gob: GobActivity,
    hour: GobHourActivity
  ) {
    elements.push(
      React.createElement(
        "a",
        {
          key: "addJobChange",
          onClick: () => this.addJobChange(gob, hour.hour),
        },
        "Add Job Change"
      )
    );
  }

  private createMenu(gob: GobActivity, hour: GobHourActivity) {
    var elements = [];

    if (!this.flags.isAuthorized) {
      return null;
    }

    var jobRun = hour.hour.jobRun;
    if (!jobRun) {
      return null;
    }

    var hasActivity = jobRun.hasActivity(gob);
    if (!hasActivity && !this.flags.isAuthorizedForToolChanges) {
      return null;
    }

    if (hasActivity) {
      if (this.flags.isAuthorizedForDefects) {
        elements.push(
          React.createElement(
            "a",
            {
              key: "addDefect",
              onClick: () => this.addDefect(gob, hour, this.props.plantId),
            },
            "Add Defect"
          )
        );
      }

      if (this.flags.isAuthorizedForToolChanges) {
        if (
          _.every(
            _.filter(this.state.activity.allActivity, "gobNumber"),
            (g) => g.currentMolds.length > 0
          )
        ) {
          var hasToolChange = jobRun.hasToolChange(gob);
          //if (hasToolChange) {
            elements.push(React.createElement("a", {
              key: "addToolChange",
              onClick: () => this.addToolChange(gob, hour, null)
            }, "Add Tool Change"));
          //}
        } else {
          this.createAddJobChangeMenuElement(elements, gob, hour);
        }
      }

      //if (this.flags.isAuthorizedForDowntime && !gob.isMachineLevel) {
      if (this.flags.isAuthorizedForDowntime) {
        elements.push(
          React.createElement(
            "a",
            {
              key: "addDowntime",
              onClick: () => this.addDowntime(gob.section, hour),
            },
            "Add Downtime"
          )
        );
      }

      if (this.flags.isAuthorizedForQualifications) {
        elements.push(
          React.createElement(
            "a",
            {
              key: "addRequalification",
              onClick: () => this.addRequalification(gob, hour.hour),
            },
            "Add Requalification"
          )
        );
      }

      if (this.flags.isAuthorizedForHourlyDowntime) {
        elements.push(
          React.createElement(
            "a",
            {
              key: "addStreaming",
              onClick: () => this.addHourlyDowntime(hour.hour),
            },
            "Add Streaming"
          )
        );
      }
    } else {
      this.createAddJobChangeMenuElement(elements, gob, hour);
    }

    if (elements.length > 0) {
      return React.createElement(
        "div",
        { key: "addMenu", className: "add-menu" },
        elements
      );
    } else {
      return null;
    }
  }

  private createDatePicker() {
    var formattedDate = this.state.currentDate.format(Strings.DATE_FORMAT);

    var elements = [];
    if (!this.isLive()) {
      elements.push(
        React.createElement("i", {
          key: "next",
          className: "fa fa-arrow-circle-o-left",
          onClick: () => this.nextDate(),
        })
      );
    }

    elements.push(
      React.createElement(
        "a",
        {
          key: "picker",
          ref: (r) => (this.datePicker = r),
        },
        formattedDate
      )
    );

    elements.push(
      React.createElement("i", {
        key: "prev",
        className: "fa fa-arrow-circle-o-right",
        onClick: () => this.prevDate(),
      })
    );

    elements.push(React.createElement("br", { key: "break" }));

    if (!this.isLive()) {
      elements.push(
        React.createElement(
          "span",
          {
            key: "goLive",
            onClick: () => this.goToLive(),
          },
          "Go to Live"
        )
      );
    }

    return React.createElement(
      "tr",
      { key: "datePicker" },
      React.createElement(
        "th",
        { key: "datePickerTh", colSpan: "5" } as React.ClassAttributes<Element>,
        elements
      )
    );
  }

  render(): JSX.Element {
    if (this.state === null) {
      return React.createElement("div", {
        key: "lineSheet",
        className: "lineSheet",
      });
    }

    var currentJob = this.currentJob();
    var jobName = "No job currently running";
    var days = "";
    if (currentJob) {
      jobName = currentJob.jobName;
      days =
        "(Day " +
        (moment(this.state.currentDate).diff(
          moment(currentJob.startDate),
          "days"
        ) +
          1) +
        ")";
    }

    return React.createElement(
      "div",
      { key: "lineSheet", className: "lineSheet" },
      React.createElement(
        "div",
        { key: "header", className: "linesheet-head" },
        React.createElement(
          "div",
          { key: "topBox", className: "topbox linedetails is-hidden-small" },
          React.createElement(
            "h2",
            { key: "shop" },
            "Shop " + this.state.activity.name
          ),
          React.createElement("h1", { key: "days" }, days),
          React.createElement("h3", { key: "job" }, jobName)
        ),
        this.createActiveMnr(),
        this.createCriticalDefectsIndicator(),
        React.createElement(
          "div",
          { key: "wnk", className: "linedash-w" },
          React.createElement(
            "div",
            { key: "wnkHE", className: "linedashitem" },
            React.createElement(
              "div",
              { key: "icon", className: "dash-ref is-hidden-small" },
              React.createElement("img", {
                key: "bottle",
                className: "bottle-icon",
              })
            ),
            React.createElement(KpiComponent, {
              plantId: this.props.plantId,
              shopId: this.props.shopId,
              wellKnownCheck: apsEnums.WellKnownCheckType.HotEndEfficiency,
            })
          ),
          React.createElement(
            "div",
            { key: "wnkPE", className: "linedashitem" },
            React.createElement(
              "div",
              { key: "icon", className: "dash-ref is-hidden-small" },
              React.createElement("i", {
                key: "dropBox",
                className: "fa fa-dropbox",
              })
            ),
            React.createElement(KpiComponent, {
              plantId: this.props.plantId,
              shopId: this.props.shopId,
              wellKnownCheck: apsEnums.WellKnownCheckType.ShopPackEfficiency,
            })
          )
        )
      ),
      React.createElement(
        "div",
        { key: "detail", className: "linesheet-w" },
        React.createElement(
          "div",
          { key: "side", className: "left-line" },
          React.createElement(
            "table",
            {
              key: "sideTable",
              cellPadding: "0",
              cellSpacing: "0",
            } as React.ClassAttributes<Element>,
            React.createElement(
              "thead",
              { key: "header" },
              this.createDatePicker()
            ),
            React.createElement("tbody", { key: "body" }, this.getSideRows())
          )
        ),
        React.createElement(
          "div",
          { key: "main", className: "linesheet-main" },
          React.createElement(
            "table",
            {
              key: "mainTable",
              id: "linesheet-data",
              cellPadding: "0",
              cellSpacing: "0",
              className: this.isLive() ? "live" : null,
            },
            React.createElement("thead", { key: "header" }, this.getHeader()),
            React.createElement("tbody", { key: "body" }, this.getBody())
          )
        )
      )
    );
  }

  private addToolChange(
    gob: GobActivity,
    gobHour: GobHourActivity,
    defect: DefectActivity,
    toolChanges?: TopToolChange,
    defectCause?: apsViewModels.DefectCauseSelection
  ) {
    var hour = gobHour.hour;
    let result = openAddToolChange(
      {
        shopId: this.props.shopId,
        gob: gob,
        gobHour: gobHour,
        date: hour ? hour.startTime : new Date(),
        activity: this.state.activity,
        defectFixed: defect,
        toolChanges: toolChanges,
        defectCause: defectCause,
      },
      LineSheetComponent.$modal
    );

    result.then((event) => {
      if (event) {
        var activity = this.state.activity;
        if (toolChanges) {
          activity.editToolChangeFromEvent(event as apsEvents.ToolChangeEdited);
        } else {
          activity.addToolChangeFromEvent(event as apsEvents.ToolChangeAdded);
        }
        this.updateActivity(activity);
      }
    });
  }

  private reviewDefectCause(
    gob: GobActivity,
    gobHour: GobHourActivity,
    defect: DefectActivity
  ) {
    let result = openDefectCauses(
      {
        defect: defect,
      },
      LineSheetComponent.$modal
    );

    if (this.flags.isAuthorizedForToolChanges) {
      result.then((defectCause) => {
        if (defectCause) {
          this.addToolChange(gob, gobHour, defect, null, defectCause);
        }
      });
    }
  }

  private viewDefect(
    gob: GobActivity,
    gobHour: GobHourActivity,
    defect: DefectActivity,
    readOnly: boolean
  ) {
    var hour = gobHour.hour;

    var result = openViewDefect(
      {
        defectId: null,
        defect: defect,
        gob: gob,
        readOnly:
          readOnly ||
          (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
        canComment:
          this.flags.isAdmin ||
          (!(hour.isLocked || gobHour.disabled) && !readOnly),
        plantId: this.props.plantId,
      },
      LineSheetComponent.$modal
    );

    result.then((reviewDefect) => {
      if ((reviewDefect || "") === true) {
        this.reviewDefectCause(gob, gobHour, defect);
      }
    });
  }

  private viewToolChange(
    gob: GobActivity,
    gobHour: GobHourActivity,
    toolChanges: TopToolChange,
    readOnly: boolean
  ) {
    var hour = gobHour.hour;
    let result = openViewToolChange(
      {
        timeZoneId: this.state.activity.timeZoneId,
        toolChanges: toolChanges,
        readOnly:
          readOnly ||
          (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
        canComment:
          (this.flags.isAdmin || !(hour.isLocked || gobHour.disabled)) &&
          (this.flags.isAuthorizedForToolChanges ||
            this.flags.isAuthorizedForToolChangesComment),
        canEdit:
          (this.flags.isAdmin || !(hour.isLocked || gobHour.disabled)) &&
          this.flags.isAuthorizedForToolChanges,
      },
      LineSheetComponent.$modal
    );

    result.then((data) => {
      if (data && data.action) {
        if (data.action === "edit") {
          this.addToolChange(gob, gobHour, null, toolChanges);
        } else if (data.action === "delete") {
          this.updateActiveMnr();
          // TODO: remove tool change from line sheet
        } else if (data.action === "addComment") {
          // TODO: add comment to line sheet
        }
      }
    });
  }

  private viewDowntime(
    section: SectionActivity,
    gobHour: GobHourActivity,
    downtime: DowntimeActivity,
    readOnly: boolean
  ) {
    let hour = gobHour.hour;
    var result = openAddDowntime(
      {
        section: section,
        shopId: this.props.shopId,
        date: hour.startTime,
        timeZoneId: this.state.timeZone,
        downtime: downtime,
        readOnly:
          readOnly ||
          (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
        canComment:
          this.flags.isAdmin ||
          (!(hour.isLocked || gobHour.disabled) && !readOnly),
      },
      LineSheetComponent.$modal
    );

    result.then((events) => {
      if (events) {
        var activity = this.state.activity;
        _.forEach(events, (event) => {
          activity.addDowntimeFromEvent(event);
        });
        this.updateActivity(activity);
      }
    });
  }

  private addDowntime(section: SectionActivity, gobHour: GobHourActivity) {
    this.viewDowntime(section, gobHour, null, false);
  }

  private addDefect(
    gob: GobActivity,
    gobHour: GobHourActivity,
    plantId: string
  ) {
    var hour = gobHour.hour;

    let result = openAddDefect(
      {
        gob: gob,
        date: hour.startTime,
        plantId: plantId,
      },
      LineSheetComponent.$modal
    );

    result.then((result) => {
      if (result) {
        var activity = this.state.activity;
        activity.addDefectFromEvent(result.event);
        this.updateActivity(activity);
        this.getLineSheetActivityWithoutBlocking();
        if (this.flags.isHotEndOperator) {
          var cavity;
          if (result.event.section) {
            cavity = _.find(
              activity.gobs,
              (g) =>
                g.gobNumber === result.event.gob &&
                g.section.sectionNumber === result.event.section
            );
          } else {
            cavity = gob.section.machine.machineLevelActivity;
          }
          this.reviewDefectCause(cavity, gobHour, result.command);
        }
      }
    });
  }

  private addHourlyDowntime(hour: HourActivity) {
    LineSheetComponent.checkListInstancesService
      .getWellKnownCheckListInstance(
        this.props.shopId,
        apsEnums.WellKnownCheckList.HourlyDowntime,
        hour.startTime
      )
      .then((data) => {
        if (!data) {
          return;
        }

        openFillOutCheckList(
          {
            checkListId: data.checkListId,
            instanceId: data.id,
            plantId: data.plantId,
            plantLocationId: data.plantLocationId,
            shopId: data.shopId,
            tankId: data.tankId,
            scheduledOn: data.scheduledOn,
          },
          LineSheetComponent.$modal
        );
      });
  }

  private addRequalification(gob: GobActivity, hour: HourActivity) {
    openAddRequalification(
      {
        shopId: this.props.shopId,
        gob: gob,
        date: hour.startTime,
        activity: this.state.activity,
        section: null,
      },
      LineSheetComponent.$modal
    );
  }

  private addJobChange(gob: GobActivity, hour: HourActivity) {
    openAddJobChange(
      {
        gob: gob,
        hour: hour,
        shopId: this.props.shopId,
        activity: this.state.activity,
      },
      LineSheetComponent.$modal
    );
  }

  private updateActivity(activity: ShopActivity) {
    if (this.isUnmounted) {
      return;
    }
    setTimeout(() => {
      this.updateActiveMnr();
    }, 2000);

    this.setState({
      activityData: this.state.activityData,
      defectTypes: this.state.defectTypes,
      tools: this.state.tools,
      equipment: this.state.equipment,
      activity: activity,
      maxDate: this.state.maxDate,
      currentDate: this.state.currentDate,
      initialDate: this.state.initialDate,
      timeZone: this.state.timeZone,
      activeMnr: this.state.activeMnr,
      userProfileData: this.state.userProfileData,
      machineVisibility: this.state.machineVisibility,
      jobs: this.state.jobs,
      jobProcesses: this.state.jobProcesses,
    });
  }
}

export default angular
  .module("aps.controller.lineSheet.react", requires)
  .factory(
    "LineSheetComponent",
    (
      lineSheetService: LineSheetService,
      loaderService: LoaderService,
      $q: angular.IQService,
      $state: angular.ui.IStateService,
      authDataService: AuthDataService,
      lineSheetHub: LineSheetHubService,
      tempDataService: TempDataService,
      defectTypeService: DefectTypeService,
      defectService: DefectService,
      toolChangeService: ToolChangeService,
      $timeout: angular.ITimeoutService,
      checkListsService: CheckListsService,
      checkListInstancesService: CheckListInstancesService,
      kpiChecksHubService: KPIChecksHubService,
      navigationService: NavigationService,
      jobService: JobService,
      userProfile: UserProfile,
      $modal: mm.foundation.modal
    ) => {
      LineSheetComponent.lineSheetService = lineSheetService;
      LineSheetComponent.loaderService = loaderService;
      LineSheetComponent.$q = $q;
      LineSheetComponent.userProfile = userProfile;
      LineSheetComponent.$state = $state;
      LineSheetComponent.defectTypeService = defectTypeService;
      LineSheetComponent.toolChangeService = toolChangeService;
      LineSheetComponent.defectService = defectService;
      LineSheetComponent.$modal = $modal;
      LineSheetComponent.tempDataService = tempDataService;
      LineSheetComponent.authDataService = authDataService;
      LineSheetComponent.lineSheetHub = lineSheetHub;
      LineSheetComponent.$timeout = $timeout;
      LineSheetComponent.navigationService = navigationService;
      LineSheetComponent.checkListInstancesService = checkListInstancesService;
      KpiComponent.checkListsService = checkListsService;
      KpiComponent.kpiChecksHubService = kpiChecksHubService;
      LineSheetComponent.jobService = jobService;
      return LineSheetComponent;
    }
  ).name;



// WEBPACK FOOTER //
// ./src/app/controllers/linesheet/lineSheet.react.ts